import { tabValues } from '../constants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const checkIsActiveTabSearchParamValid = (value) => {
  const validValuesList = Object.values(tabValues)

  if (validValuesList.includes(value)) {
    return value
  }

  return tabValues.CLINIC_MEMBERS
}
